import { Injectable } from '@angular/core'

@Injectable({
  providedIn: 'root',
})
export class DdcLoggerService {
  DEBUG = false
  INFO = true
  WARN = false
  ERROR = false

  debug(message: any, ...optionalParams: any[]): void {
    if (this.DEBUG) {
    }
  }

  info(message: any, ...optionalParams: any[]): void {
    if (this.INFO) {
    }
  }

  warn(message: any, ...optionalParams: any[]): void {
    if (this.WARN) {
    }
  }

  error(message: any, ...optionalParams: any[]): void {
    if (this.ERROR) {
    }
  }
}
